import React, { useMemo } from 'react'
import styled, { css } from 'styled-components'
import { Table as AntdTable } from 'antd'
import { selectedRow } from 'ui/styled-variables'
import {
  BLUE_LIGHT,
  GREY_SECONDARY,
  GREY_500,
  SILVER,
  ANTIQUE_WHITE,
  BLUE,
  GREY_SWEET
} from 'ui/constants'

/* Component created to avoid passing
/* required rowClassName styling */

const Table = props => {
  const { mixCellTestId, columns, ...rest } = props

  const enhancedColumns = useMemo(() => {
    if (!mixCellTestId || !columns) return columns

    return columns.map(col => {
      const id = col.dataIndex ?? col.key ?? 'not_found'
      return {
        ...col,
        onCell: () => ({ 'data-test': `cell_${id}` })
      }
    })
  }, [mixCellTestId, columns])

  return (
    <StyledTable
      rowClassName={(_, index) => index % 2 && 'even'}
      pagination={false}
      size="middle"
      rowKey={item =>
        item.id || item.key || `${item.name}-${item.first_observed}`
      }
      columns={enhancedColumns}
      {...rest}
    />
  )
}

const StyledTable = styled(AntdTable)`
  ${({ padding, overflowVisible }) => css`
    .even {
      background: ${GREY_500};
    }

    ${overflowVisible &&
    `.ant-table-header {
      overflow: visible !important;
    }`}

    .ant-table-cell.ant-table-cell-scrollbar {
      background-color: ${BLUE_LIGHT};
      box-shadow: none;
    }

    .ant-table-thead > tr > th {
      background: ${BLUE_LIGHT};
      padding: 16px;
      color: ${GREY_SECONDARY};
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
      height: 52px;
    }

    .ant-table-tbody > tr > td {
      height: 64px;
    }

    .ant-table-tbody > tr > td:has(.bordered) {
      border-bottom: 1px solid ${GREY_SWEET};
      padding: 0;

      &:hover {
        border-bottom: 1px solid ${BLUE};
      }
    }

    .ant-table-column-sorters {
      padding: 0;
    }

    & tr {
      cursor: pointer;
    }

    .rowClassName1 td:first-child {
      border-top-left-radius: 10px;
    }

    padding: ${padding || '0 30px'};

    .inactive {
      background: ${ANTIQUE_WHITE};
    }

    .locked {
      background: ${SILVER};
    }

    ${selectedRow}
  `}
`

export default Table
